import { AxiosResponse } from "axios";
import { KnowledgeType } from "../util/KnowledgeType";
import {
  ConversationKnowledge,
  KnowledgeResponse,
  KnowledgeCard,
  KnowledgeItem,
  KnowledgeSummary,
} from "./responsePayload/KnowledgeResponse";
import {
  apiDownloadRequest,
  apiGetRequest,
  apiPostRequest,
  createPayload,
} from "./util/apiUtils";
import { Endpoint } from "./util/contants";
import {
  mapKnowledgeConversationData,
  mapKnowledgeCardData,
} from "./util/responseMap";

export const AllConversation = async (
  endpoint: string | undefined = Endpoint.Knowledge,
  pathVariables: Record<string, any> = {},
  queryParams: Record<string, any> = {}
): Promise<ConversationKnowledge | null> => {
  const apiResponse = await apiGetRequest<KnowledgeResponse>(
    endpoint,
    pathVariables,
    queryParams
  );

  if (!apiResponse) {
    throw new Error("Failed to fetch data from the API.");
  }

  return mapKnowledgeConversationData(apiResponse);
};

export const GetBrainId = async (
  brainId: number | undefined = undefined,
  knowledgeType: KnowledgeType | undefined = undefined
): Promise<KnowledgeCard[] | undefined> => {
  try {
    const apiResponse = await apiGetRequest<KnowledgeItem>(
      Endpoint.KnowledgeId,
      {
        id: brainId,
      },
      {
        type: knowledgeType,
        in_brain: true,
      }
    );

    if (!apiResponse) {
      throw new Error("Failed to fetch data from the API.");
    }
    return mapKnowledgeCardData(apiResponse);
  } catch {
    return undefined;
  }
};

export const GetBrain = async (
  endpoint: string | undefined = Endpoint.KnowledgeId,
  knowledgeType: KnowledgeType | undefined = undefined,
  brainId: number | undefined = undefined,
  page: number | undefined = undefined,
  search: string | undefined = undefined
): Promise<ConversationKnowledge | null> => {
  const apiResponse = await apiGetRequest<KnowledgeResponse>(
    endpoint,
    {
      id: brainId,
    },
    {
      page: page,
      type: knowledgeType,
      in_brain: true,
      ...(search && { search: search }),
    }
  );
  if (!apiResponse) {
    throw new Error("Failed to fetch data from the API.");
  }
  return mapKnowledgeConversationData(apiResponse);
};

export const KowledgeSummary = async (
  pathVariables: Record<string, any> = {},
  queryParams: Record<string, any> = {}
): Promise<KnowledgeSummary | undefined> => {
  const query = {
    in_brain: false,
    ...{ queryParams },
  };
  return await apiGetRequest<KnowledgeSummary>(
    Endpoint.KnowledgeSummary,
    pathVariables,
    query
  );
};

export const SearchBrain = async (
  endpoint: string | undefined = Endpoint.KnowledgeId,
  queryParams: Record<string, any> = {}
): Promise<ConversationKnowledge | undefined> => {
  const res = await apiGetRequest<KnowledgeResponse>(
    endpoint,
    { id: undefined },
    queryParams
  );
  if (!res) {
    throw new Error("Failed to fetch data from the API.");
  }
  return mapKnowledgeConversationData(res);
};

export const BrainBulkDelete = async (
  ids: number[]
): Promise<AxiosResponse | null> => {
  const basePayload = {
    knowledge_content_ids: ids,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.BrainBulkRemove, payload);
};

export const ExportCategoryAPi = async (
  exportContent: string
): Promise<void> => {
  const pathQuery = {
    id: exportContent,
  };
  await apiDownloadRequest(Endpoint.Export, pathQuery, {});
};
